import { styled } from "../stitches.config";

export const Code = styled("code", {
  fontFamily: "$mono",
  fontSize: "max(12px, 85%)",
  whiteSpace: "nowrap",
  padding: "0 3px 2px 3px",

  variants: {
    variant: {
      gray: {
        backgroundColor: "$neutral3",
        color: "$neutral11",
      },
      violet: {
        backgroundColor: "$violet3",
        color: "$violet11",
      },
    },
  },
  defaultVariants: {
    variant: "violet",
  },
});
